import React, { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import {
	CustomButton,
	SidePanel,
	SidePanelContent,
	icon,
	IconComponent,
	CustomTextField,
} from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DistributionListSidePanel.module.css";

export default function DistributionListSidePanel({ open, territory, onClose, onSave }) {
	const [email, setEmail] = useState("");
	const [error, setError] = useState(false);

	useEffect(() => {
		if (territory) {
			setEmail(territory.email || "");
			setError(false);
		}
	}, [territory]);

	const isValidEmail = (value) => /^[a-zA-Z0-9+_.-]+@[\w\d.-]+\.[\w\d.-]+/.test(value);

	const handleChangeEmail = (e) => {
		setEmail(e.target.value);
		setError(false);
	};

	const handleSubmit = () => {
		if (!isValidEmail(email)) {
			setError(true);
			return;
		}
		onSave(territory.id, email);
	};

	const handleClose = () => {
		setEmail("");
		setError(false);
		onClose();
	};

	return (
		<SidePanel open={open} size={38} onClose={handleClose}>
			<SidePanelContent title={translate("admin.distribution-list.side-panel.title")} onClose={handleClose}>
				<div className={styles.wrapper}>
					<div className={styles.container}>
						<div className={styles.territoryInfo}>
							<span className={styles.label}>
								{translate("admin.distribution-list.side-panel.territory")}
							</span>
							<span className={styles.value} translate="no">
								{territory?.territoryName}
							</span>
						</div>
						<div className={styles.emailBlock}>
							<label className={styles.inputLabel} htmlFor="email-input">
								{translate("admin.distribution-list.side-panel.email.label")}
								<span className={styles.asterisk}>*</span>
							</label>
							<CustomTextField
								fullWidth
								required
								className={styles.emailField}
								error={error}
								helperText={error && translate("common:multiple-email-input.error-message.not-valid")}
								id="email-input"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconComponent icon={icon.faAt} />
										</InputAdornment>
									),
								}}
								placeholder="exemple@email.com"
								sx={{
									"& .MuiOutlinedInput-input": {
										padding: "8px",
									},
								}}
								value={email}
								variant="outlined"
								onChange={handleChangeEmail}
							/>
						</div>
					</div>
					<div className={styles.actions}>
						<CustomButton color="secondary" variant="outlined" onClick={handleClose}>
							{translate("common:btn.cancel")}
						</CustomButton>
						<CustomButton color="primary" variant="contained" onClick={handleSubmit}>
							{translate("common:btn.validate")}
						</CustomButton>
					</div>
				</div>
			</SidePanelContent>
		</SidePanel>
	);
}
